import { render, staticRenderFns } from "./FilterSection.component.vue?vue&type=template&id=81c45230&scoped=true"
import script from "./FilterSection.component.vue?vue&type=script&lang=ts"
export * from "./FilterSection.component.vue?vue&type=script&lang=ts"
import style0 from "./FilterSection.component.vue?vue&type=style&index=0&id=81c45230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c45230",
  null
  
)

export default component.exports